module.exports = __webpack_public_path__ + "ffc53aef733ae95215eea8bba704e2f1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/sofas/sofa-gamer.png
// module id = 1594
// module chunks = 0